<template>
<div class="chapter">
<div class="inner_page">
<h2 style="margin-bottom:1em; margin-left:0em;">Table of Contents</h2>
<p class="toc" id="rded"><a href="#/006_dedication#ded">DEDICATION</a></p>
<p class="toc" id="rack"><a href="#/007_acknowledgements#ack">ACKNOWLEDGEMENTS</a></p>
<p class="toc" id="rch1"><a href="#/008_chapter1#ch1">CHAPTER 1</a></p>
<p class="toc" id="rch2"><a href="#/009_chapter2#ch2">CHAPTER 2</a></p>
<p class="toc" id="rch3"><a href="#/010_chapter3#ch3">CHAPTER 3</a></p>
<p class="toc" id="rch4"><span href="#/011_chapter4#ch4" title="Link target outside of Sample">CHAPTER 4</span></p>
<p class="toc" id="rch5"><span href="#/012_chapter5#ch5" title="Link target outside of Sample">CHAPTER 5</span></p>
<p class="toc" id="rch6"><span href="#/013_chapter6#ch6" title="Link target outside of Sample">CHAPTER 6</span></p>
<p class="toc" id="rch7"><span href="#/014_chapter7#ch7" title="Link target outside of Sample">CHAPTER 7</span></p>
<p class="toc" id="rch8"><span href="#/015_chapter8#ch8" title="Link target outside of Sample">CHAPTER 8</span></p>
<p class="toc" id="rch9"><span href="#/016_chapter9#ch9" title="Link target outside of Sample">CHAPTER 9</span></p>
<p class="toc" id="rch10"><span href="#/017_chapter10#ch10" title="Link target outside of Sample">CHAPTER 10</span></p>
<p class="toc" id="rch11"><span href="#/018_chapter11#ch11" title="Link target outside of Sample">CHAPTER 11</span></p>
<p class="toc" id="rch12"><span href="#/019_chapter12#ch12" title="Link target outside of Sample">CHAPTER 12</span></p>
<p class="toc" id="rch13"><span href="#/020_chapter13#ch13" title="Link target outside of Sample">CHAPTER 13</span></p>
<p class="toc" id="rch14"><span href="#/021_chapter14#ch14" title="Link target outside of Sample">CHAPTER 14</span></p>
<p class="toc" id="rch15"><span href="#/022_chapter15#ch15" title="Link target outside of Sample">CHAPTER 15</span></p>
<p class="toc" id="rch16"><span href="#/023_chapter16#ch16" title="Link target outside of Sample">CHAPTER 16</span></p>
<p class="toc" id="rch17"><span href="#/024_chapter17#ch17" title="Link target outside of Sample">CHAPTER 17</span></p>
<p class="toc" id="rch18"><span href="#/025_chapter18#ch18" title="Link target outside of Sample">CHAPTER 18</span></p>
<p class="toc" id="rch19"><span href="#/026_chapter19#ch19" title="Link target outside of Sample">CHAPTER 19</span></p>
<p class="toc" id="rch20"><span href="#/027_chapter20#ch20" title="Link target outside of Sample">CHAPTER 20</span></p>
<p class="toc" id="rch21"><span href="#/028_chapter21#ch21" title="Link target outside of Sample">CHAPTER 21</span></p>
<p class="toc" id="rch22"><span href="#/029_chapter22#ch22" title="Link target outside of Sample">CHAPTER 22</span></p>
<p class="toc" id="rch23"><span href="#/030_chapter23#ch23" title="Link target outside of Sample">CHAPTER 23</span></p>
<p class="toc" id="rch24"><span href="#/031_chapter24#ch24" title="Link target outside of Sample">CHAPTER 24</span></p>
<p class="toc" id="rch25"><span href="#/032_chapter25#ch25" title="Link target outside of Sample">CHAPTER 25</span></p>
<p class="toc" id="rch26"><span href="#/033_chapter26#ch26" title="Link target outside of Sample">CHAPTER 26</span></p>
<p class="toc" id="rch27"><span href="#/034_chapter27#ch27" title="Link target outside of Sample">CHAPTER 27</span></p>
<p class="toc" id="rch28"><span href="#/035_chapter28#ch28" title="Link target outside of Sample">CHAPTER 28</span></p>
<p class="toc" id="rch29"><span href="#/036_chapter29#ch29" title="Link target outside of Sample">CHAPTER 29</span></p>
<p class="toc" id="rch30"><span href="#/037_chapter30#ch30" title="Link target outside of Sample">CHAPTER 30</span></p>
<p class="toc" id="rch31"><span href="#/038_chapter31#ch31" title="Link target outside of Sample">CHAPTER 31</span></p>
<p class="toc" id="rch32"><span href="#/039_chapter32#ch32" title="Link target outside of Sample">CHAPTER 32</span></p>
<p class="toc" id="rch33"><span href="#/040_chapter33#ch33" title="Link target outside of Sample">CHAPTER 33</span></p>
<p class="toc" id="rch34"><span href="#/041_chapter34#ch34" title="Link target outside of Sample">CHAPTER 34</span></p>
<p class="toc" id="rch35"><span href="#/042_chapter35#ch35" title="Link target outside of Sample">CHAPTER 35</span></p>
<p class="toc" id="rch36"><span href="#/043_chapter36#ch36" title="Link target outside of Sample">CHAPTER 36</span></p>
<p class="toc" id="rch37"><span href="#/044_chapter37#ch37" title="Link target outside of Sample">CHAPTER 37</span></p>
<p class="toc" id="rch38"><span href="#/045_chapter38#ch38" title="Link target outside of Sample">EPILOGUE</span></p>
<p class="toc" id="rch39"><span href="#/046_chapter39#ch39" title="Link target outside of Sample">GEMINI RISING</span></p>
<p class="toc" id="rch40"><span href="#/047_chapter40#ch40" title="Link target outside of Sample">NEXT LIFETIME</span></p>
<p class="toc" id="rser"><span href="#/048_series#ser" title="Link target outside of Sample">ABOUT THE KINGS OF THE CASTLE SERIES</span></p>
<p class="toc" id="raut"><span href="#/049_author#aut" title="Link target outside of Sample">AUTHOR BIOS</span></p>
<p class="toc" id="rmen"><span href="#/050_mentors#men" title="Link target outside of Sample">SERIES MENTORS:</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 005_contents.vue?412761c2